import React from 'react'
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import clsx from 'clsx';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    pointer: {
        cursor: 'pointer'
    }
}))

function TooltipIcon(
    {
        tooltip,
        placement = 'top',
        hideTooltip = false,
        Icon = AcUnitIcon,
        color,
        fontSize,
        onClick,
        tooltipClasses,
        iconClasses,
        ...otherProps
    }) {
    const classes = useStyles();
    if (hideTooltip || !tooltip) {
        return <Icon />
    }
    return (
        <Tooltip title={tooltip} placement={placement} classes={tooltipClasses}>
			<span>
				<Icon color={color} fontSize={fontSize} onClick={onClick} className={clsx({[classes.pointer]: !!onClick }, iconClasses)} {...otherProps}/>
			</span>
        </Tooltip>
    )
}

TooltipIcon.propTypes = {
    classes: PropTypes.any,
}

export default TooltipIcon;